import { Action } from '@ngrx/store';
import {
  MeasurementSettingsFormData,
  RotorTypeFormsData,
  SectorData,
} from 'src/utils/interfaces/rotor-type-forms-data.interfaces';
import {
  CorrectionMethodStepFormData,
  RotorTypeSettingsStepFormData,
  SupportSettingsStepFormData,
  SummaryStepFormData,
  TolerancesStepFormData,
  CorrectionLocationsStepFormData,
  CalibrationsStepFormData,
} from './rotor-type-details-store.basic';

export interface ResetStepsFormsConfig {
  keepName?: boolean;
}

export enum RotorTypeDetailActionTypes {
  SupportSettingsFormUpdate = '[RotorTypeDetails] updated form for SupportSettings step',
  RotorTypeSettingsFormUpdate = '[RotorTypeDetails] updated form for RotorTypeSettings step',
  MeasurementSettingsFormUpdate = '[RotorTypeDetails] updated form for MeasurementSettings step',
  CorrectionMethodFormUpdate = '[RotorTypeDetails] updated form for CorrectionMethod step',
  CorrectionLocationsFormUpdate = '[RotorTypeDetails] updated form for CorrectionLocations step',
  TolerancesFormUpdate = '[RotorTypeDetails] updated form for Tolerances step',
  CalibrationsAndCompensationsFormUpdate = '[RotorTypeDetails] updated form for CalibrationsAndCompensations step',
  SummaryFormUpdate = '[RotorTypeDetails] updated form for Summary step',
  ResetRotorTypeForms = '[RotorTypeDetails] reset rotor type forms',
  UpdateRotorTypeForms = '[RotorTypeDetails] update rotor type forms',
  CopySectors = '[RotorTypeDetails] copy sectors',
}
export class SupportSettingsFormUpdate implements Action {
  type: string = RotorTypeDetailActionTypes.SupportSettingsFormUpdate;
  constructor(public payload: SupportSettingsStepFormData) {}
}
export class RotorTypeSettingFormUpdate implements Action {
  type: string = RotorTypeDetailActionTypes.RotorTypeSettingsFormUpdate;
  constructor(public payload: RotorTypeSettingsStepFormData) {}
}
export class MeasurementSettingsFormUpdate implements Action {
  type: string = RotorTypeDetailActionTypes.MeasurementSettingsFormUpdate;
  constructor(public payload: MeasurementSettingsFormData) {}
}
export class CorrectionSettingFormUpdate implements Action {
  type: string = RotorTypeDetailActionTypes.CorrectionMethodFormUpdate;
  constructor(public payload: CorrectionMethodStepFormData) {}
}
export class CorrectionLocationsFormUpdate implements Action {
  type: string = RotorTypeDetailActionTypes.CorrectionLocationsFormUpdate;
  constructor(public payload: CorrectionLocationsStepFormData) {}
}
export class TolerancesFormUpdate implements Action {
  type: string = RotorTypeDetailActionTypes.TolerancesFormUpdate;
  constructor(public payload: TolerancesStepFormData) {}
}
export class CallibrationsAndCompensationsFormUpdate implements Action {
  type: string = RotorTypeDetailActionTypes.CalibrationsAndCompensationsFormUpdate;
  constructor(public payload: CalibrationsStepFormData) {}
}
export class SummaryFormUpdate implements Action {
  type: string = RotorTypeDetailActionTypes.SummaryFormUpdate;
  constructor(public payload: SummaryStepFormData) {}
}

export class ResetStepsForms implements Action {
  type: string = RotorTypeDetailActionTypes.ResetRotorTypeForms;
  constructor(public payload?: ResetStepsFormsConfig) {}
}

export class UpdateStepsForms implements Action {
  type: string = RotorTypeDetailActionTypes.UpdateRotorTypeForms;
  constructor(public payload: RotorTypeFormsData) {}
}

export class CopySectors implements Action {
  type: string = RotorTypeDetailActionTypes.CopySectors;
  constructor(public sectors: SectorData[]) {}
}
